import { j as t } from "./atoms-v218.js";
import { forwardRef as j } from "react";
import { TextSkeleton as c } from "./atoms-v2744.js";
import { Text as h } from "./atoms-v2745.js";
const u = j(
  ({
    ariaHidden: r = !1,
    ariaLabel: e = "",
    children: o,
    className: a = "",
    colorTheme: i = "light",
    id: m,
    isSkeleton: s = !1,
    lineClamp: x,
    skeletonLineCount: p = 2,
    skeletonLineHeight: n = 11,
    skeletonLineWidth: f = "100%",
    tagName: l = "div",
    type: d = "body",
    variant: T = "expressive"
  }, $) => s ? /* @__PURE__ */ t.jsx(
    c,
    {
      ariaLabel: e,
      skeletonLineCount: p,
      skeletonLineHeight: n,
      skeletonLineWidth: f
    }
  ) : /* @__PURE__ */ t.jsx(
    h,
    {
      $colorTheme: i,
      $lineClamp: x,
      $type: d,
      $variant: T,
      "aria-hidden": r,
      "aria-label": e,
      as: l,
      className: a,
      "data-testid": "text-component",
      id: m,
      ref: $,
      children: o
    }
  )
);
u.displayName = "Text";
export {
  u as Text
};
